import React from "react";
import { Button } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

export const ListButton = React.forwardRef(({ className, open, ...rest }, ref) => {
  return (
    <Button
      ref={ref}
      className={classNames(className, "list-button", {
        active: open,
      })}
      active={open}
      {...rest}
    />
  );
});

ListButton.displayName = "ListButton";

ListButton.propTypes = {
  open: PropTypes.bool,
  className: PropTypes.string,
};
